<template>
  <Card flat class="comment">
    <h3 v-if="!disabled">{{ $t('blog.comments.form_title') }}</h3>
    <a
      v-else
      @click="handleLogin"
    >
      {{ $t('blog.comments.login_comment') }}
    </a>
    <form v-if="!disabled" ref="form" class="comment-form" action @submit.prevent="save">
      <textarea
        v-model="comment.content"
        name="comment"
        cols
        rows="5"
        maxlength="255"
        required
        :disabled="disabled"
      ></textarea>
      <div class="actions">
        <Button
          type="submit"
          :disabled="disabled || loading"
        >{{ $t('blog.comments.send') }}</Button>
      </div>
    </form>
  </Card>
</template>

<script>
import Card from '../../../common/Card';
import Button from '../../../common/Button';

export default {
  name: 'Form',
  components: {
    Card,
    Button,
  },
  props: {
    user: {
      type: Object,
      description: 'Nochalks user object',
    },
    post: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    loading: false,
    comment: {
      content: '',
    },
  }),
  computed: {
    disabled() {
      return !this.user || !this.user.id;
    },
  },
  methods: {
    async save() {
      try {
        if (this.disabled || !this.$refs.form.reportValidity()) return;
        const { data } = await window.axios
          .post(`/api/blog/posts/${this.post.id}/comments/store`, {
            content: this.comment.content,
          });
        this.comment.content = '';
        this.$emit('saved', data.comment);
      } finally {
        this.loading = false;
      }
    },
    handleLogin() {
      const path = `/blog/post/${this.post.translation.slug}`;
      try {
        this.$store.commit('DIALOG_SHOW', {
          redirect: path,
        });
      } catch (e) {
        location.href = path;
      }
    },
  },
};
</script>

<style scoped>
.comment {
  flex-direction: column;
}
.comment a {
  font-size: 1rem;
  cursor: pointer;
}
.comment a:hover{
  color: var(--blog-link)
}
.comment-form {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: 0.8rem 0;
}
.comment-form textarea {
  padding: 10px;
  border-radius: 8px;
  border: 1px solid var(--blog-border)
}
.comment-form textarea[disabled] {
  border-color: #e2e2e2;
}
.comment-form .actions {
  display: flex;
  margin: 0.5rem 0;
  justify-content: flex-end;
}
</style>
